import { ComponentStyleConfig } from '@chakra-ui/react';

export const Popover: ComponentStyleConfig = {
  parts: ['content'],
  variants: {
    // 影を濃くして視認性を上げる
    darkShadow: {
      content: {
        boxShadow:
          '0 8px 12px 3px rgba(0, 0, 0, 0.25), 0 4px 6px -2px rgba(0, 0, 0, 0.2)',
        _focus: {
          boxShadow:
            '0 8px 12px 3px rgba(0, 0, 0, 0.25), 0 4px 6px -2px rgba(0, 0, 0, 0.2)',
          outline: 'none',
        },
      },
    },
  },
};
